import styled from 'styled-components';

export const TextilesAreaWrap = styled.div`
    padding-left: 90px;
    padding-bottom: 100px;
    height: 100vh;
`